import { Transaction } from 'components/TransactionAllocator';
import { CalendarDay } from 'further-ui/utils';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useCapitalActionsTransactions } from './useCapitalActionsTransactions';

type GeneralCapitalActionTransaction = {
  actionId: string;
  name: string;
  ledgerDate: CalendarDay;
  transactionTypeId: string;
  transactionSubType: string;
  operationType: TransactionOperation;
  amountIncVatTcy: number;
  amountExVatTcy: number;
  amountIncVatLcy: number;
  amountExVatLcy: number;
  commitmentId: string;
  label?: string;
  effectiveCapitalDate?: CalendarDay;
};

type UseGeneralCapitalActionsTransactionsProps = {
  generalCapitalActionsTransactions: Array<GeneralCapitalActionTransaction>;
  baseCurrency: CurrencyCode;
  savedTransactions?: Record<string, Array<Transaction>>;
};

export const useGeneralCapitalActionsTransactions = ({
  generalCapitalActionsTransactions,
  baseCurrency,
  savedTransactions,
}: UseGeneralCapitalActionsTransactionsProps) => {
  return useCapitalActionsTransactions({
    capitalActionsTransactions: generalCapitalActionsTransactions,
    baseCurrency,
    savedTransactions,
  });
};
